import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Search } from 'lucide-react';
import PageLayout from '@/components/layout/PageLayout';

const NotFoundPage = () => {
  useEffect(() => {
    // Set noindex for 404 pages
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) { robots = document.createElement('meta'); robots.setAttribute('name', 'robots'); document.head.appendChild(robots); }
    robots.setAttribute('content', 'noindex, nofollow');
    document.title = 'Page Not Found — Taxera Technologies';
    return () => { robots.setAttribute('content', 'index, follow'); };
  }, []);

  return (
    <PageLayout>
      <div className="min-h-[70vh] flex items-center justify-center py-20 px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-lg text-center"
        >
          <div className="w-20 h-20 rounded-2xl bg-slate-100 flex items-center justify-center mx-auto mb-8">
            <Search className="w-10 h-10 text-slate-400" strokeWidth={1.5} />
          </div>

          <h1 className="font-heading text-6xl font-bold text-taxera-charcoal mb-3" data-testid="404-title">
            404
          </h1>
          <h2 className="font-heading text-xl font-bold text-taxera-charcoal mb-4">
            Page not found
          </h2>
          <p className="text-slate-500 mb-8 leading-relaxed">
            The page you're looking for doesn't exist or has been moved. Let's get you back on track.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="group inline-flex items-center justify-center gap-2 px-6 py-3 taxera-gradient text-white rounded-full font-semibold text-sm hover:shadow-lg transition-all"
              data-testid="404-home-btn"
            >
              <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
              Back to Home
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white border border-slate-200 text-taxera-charcoal rounded-full font-semibold text-sm hover:bg-slate-50 transition-all"
              data-testid="404-contact-btn"
            >
              Contact Us
            </Link>
          </div>
        </motion.div>
      </div>
    </PageLayout>
  );
};

export default NotFoundPage;
